import { httpClient } from './http-client';

export interface ContributionLimit {
  id: string;
  household_id: string;
  group_name: string;
  contribution_year: number;
  limit_amount: string;
  currency: string;
  start_date: string;
  end_date?: string | null;
  account_ids: string[];
  created_at: string;
  updated_at: string;
}

export interface ContributionAccountProgress {
  account_id: string;
  contributions_native: string;
  contributions_base: string;
  withdrawals_native: string;
  withdrawals_base: string;
  currency: string;
}

export interface ContributionProgress {
  limit: ContributionLimit;
  total_contributions_base: string;
  total_withdrawals_base: string;
  remaining_base: string;
  accounts: ContributionAccountProgress[];
}

export interface ContributionLimitRequest {
  group_name: string;
  contribution_year: number;
  limit_amount: string;
  currency?: string;
  start_date: string;
  end_date?: string;
  account_ids: string[];
}

export class ContributionLimitsService {
  private static readonly BASE_URL = '/contribution-limits';

  static async list(): Promise<ContributionLimit[]> {
    const raw = await httpClient.get<any>(ContributionLimitsService.BASE_URL);
    return (raw as any).data || raw;
  }

  static async create(data: ContributionLimitRequest): Promise<ContributionLimit> {
    const raw = await httpClient.post<any>(ContributionLimitsService.BASE_URL, data);
    return (raw as any).data || raw;
  }

  static async update(id: string, data: ContributionLimitRequest): Promise<ContributionLimit> {
    const raw = await httpClient.put<any>(`${ContributionLimitsService.BASE_URL}/${id}`, data);
    return (raw as any).data || raw;
  }

  static async delete(id: string): Promise<void> {
    await httpClient.delete(`${ContributionLimitsService.BASE_URL}/${id}`);
  }

  static async progress(id: string): Promise<ContributionProgress> {
    const raw = await httpClient.get<any>(`${ContributionLimitsService.BASE_URL}/${id}/progress`);
    return (raw as any).data || raw;
  }
}
